module.exports = __webpack_public_path__ + "img/level_one.7d97299d.png";